export enum EventPriceToMembershipType {
	Free = 'free',
	HalfPrice = 'half-price',
	FullPrice = 'full-price',
	CustomPrice = 'custom-price',
}

export enum EventWaiverTypeEnum {
	Url = 'url',
	Text = 'text',
}

export enum EventTypeEnum {
	Paid = 'paid',
	Free = 'free',
	Donation = 'donation',
}
